<template>
  <div class="input-wrapper" v-if="show">
    <div v-if="label || tooltip">
      <label v-if="label" class="input-label" v-html="inputLabel"></label>
      <Tooltip v-if="tooltip" :text="tooltip" class="tooltip"></Tooltip>
    </div>
    <slot>
      <textarea
        v-if="type === 'textarea'"
        :id="`input-item-${model}`"
        class="input-style"
        :value="value"
        :type="type"
        :placeholder="placeholder"
        @keyup="updateValue"
      />

      <input
        v-else
        :id="`input-item-${model}`"
        class="input-style"
        :value="value"
        :type="type"
        :placeholder="placeholder"
        :min="min"
        :step="step"
        @keyup="updateValue"
        @mouseup="updateValue"
      />
    </slot>
  </div>
</template>

<script>
import Tooltip from '../Tooltip';

export default {
  props: {
    parent: Object,
    model: String,
    label: String,
    type: {
      default: 'text',
      type: String,
    },
    placeholder: String,
    tooltip: String,
    min: String,
    step: String,
    handleKeyup: Function,
    transformValue: Function,
    show: {
      default: true,
      type: Boolean,
    },
    optional: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      KEYUP_TIMER: 250,
      keyupInterval: null,
    };
  },
  components: { Tooltip },
  computed: {
    value() {
      if (!this.parent || !this.model) return;

      return this.parent[this.model];
    },
    inputLabel() {
      return this.label
        ? `${this.label}${this.optional ? ' (optional)' : ''}`
        : null;
    },
  },
  methods: {
    updateValue(e) {
      if (!this.show) return;

      if (this.keyupInterval) clearInterval(this.keyupInterval);
      this.keyupInterval = setTimeout(() => {
        if (this.handleKeyup) {
          return this.handleKeyup(e, this.model);
        }
        let { value } = e.srcElement;

        if (this.transformValue) {
          value = this.transformValue(value);
        }

        this.$set(this.parent, this.model, value);
      }, this.KEYUP_TIMER);
    },
  },
  watch: {},
};

</script>

<style scoped>
  .input-wrapper {
    width: 100%;
    max-width: 100%;
    margin: 10px 0 20px 0;
    font-size: 12px;
    text-align: left;
  }

  .tooltip {
    font-size: 12px;
  }

  .input-label {
    text-transform: uppercase;
    display: inline-block;
    letter-spacing: 1px;
    margin-bottom: 5px;
  }

  .input-style {
    padding: 10px;
    font-size: 12px;
    width: 100%;
    box-sizing: border-box;
    border: 1px solid rgba(0, 0, 0, 0.14);
  }
</style>
